var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-modal', {
    attrs: {
      "id": "raiseIssueModal",
      "centered": "",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "hide-header-close": "",
      "modal-class": "iha-modal"
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "view-clients-header"
        }, [_c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.modalVisible,
      callback: function callback($$v) {
        _vm.modalVisible = $$v;
      },
      expression: "modalVisible"
    }
  }, [_c('div', {
    staticClass: "issue-modal-card"
  }, [_c('h5', {
    staticClass: "modal-title mb-3"
  }, [_vm._v("Raise an Securus Issue")]), _c('div', {
    staticClass: "issue-info"
  }, [_c('label', {
    staticClass: "section-label mb-2"
  }, [_vm._v("Raising Issue For")]), _vm.row ? _c('div', {
    staticClass: "issue-user"
  }, [_c('div', {
    staticClass: "issue-name-intial d-flex align-items-center justify-content-center"
  }), _c('div', {
    staticClass: "issue-details"
  }, [_c('div', {
    staticClass: "issue-name d-flex align-items-center "
  }, [_c('span', {
    staticClass: "icon-wrap d-flex align-items-center justify-content-center"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M15.71 12.71a6 6 0 1 0-7.42 0a10 10 0 0 0-6.22 8.18a1 1 0 0 0 2 .22a8 8 0 0 1 15.9 0a1 1 0 0 0 1 .89h.11a1 1 0 0 0 .88-1.1a10 10 0 0 0-6.25-8.19M12 12a4 4 0 1 1 4-4a4 4 0 0 1-4 4"
    }
  })])]), _vm._v(" " + _vm._s(_vm.row.first_name) + " " + _vm._s(_vm.row.last_name) + " ")]), _c('div', {
    staticClass: "issue-plan d-flex align-items-center "
  }, [_c('span', {
    staticClass: "icon-wrap d-flex align-items-center justify-content-center"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M19.903 8.586a1 1 0 0 0-.196-.293l-6-6a1 1 0 0 0-.293-.196c-.03-.014-.062-.022-.094-.033a1 1 0 0 0-.259-.051C13.04 2.011 13.021 2 13 2H6c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V9c0-.021-.011-.04-.013-.062a1 1 0 0 0-.051-.259q-.014-.048-.033-.093M16.586 8H14V5.414zM6 20V4h6v5a1 1 0 0 0 1 1h5l.002 10z"
    }
  }), _c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M8 12h8v2H8zm0 4h8v2H8zm0-8h2v2H8z"
    }
  })])]), _vm._v(" " + _vm._s(_vm.row.plan_details && _vm.row.plan_details[0] ? _vm.row.plan_details[0].plan_name_system_new : 'N/A') + " ")])])]) : _vm._e()]), _c('div', {
    staticClass: "form-group mb-3 position-relative d-block"
  }, [_c('label', {
    staticClass: "mb-2"
  }, [_vm._v("Issue Type "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _c('div', {
    staticClass: "position-relative"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.status,
      expression: "status"
    }],
    staticClass: "form-control custom-select",
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }, function ($event) {
        _vm.markError = '';
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Type")]), _vm._l(_vm.issueTypes, function (item) {
    return _c('option', {
      key: item,
      domProps: {
        "value": item
      }
    }, [_vm._v(" " + _vm._s(item) + " ")]);
  })], 2), _c('i', {
    staticClass: "fas fa-angle-down dropdown-icon"
  })]), _vm.markError ? _c('small', {
    staticClass: "field-error"
  }, [_vm._v(_vm._s(_vm.markError))]) : _vm._e()]), _c('div', {
    staticClass: "form-group mb-3 d-block"
  }, [_c('label', {
    staticClass: "mb-2"
  }, [_vm._v("Issue Description "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.note,
      expression: "note"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "placeholder": "Describe the issue..."
    },
    domProps: {
      "value": _vm.note
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.note = $event.target.value;
      }, function ($event) {
        _vm.noteError = '';
      }]
    }
  }), _vm.noteError ? _c('small', {
    staticClass: "field-error"
  }, [_vm._v(_vm._s(_vm.noteError))]) : _vm._e()]), _c('div', {
    staticClass: "form-group mb-3"
  }, [_c('label', {
    staticClass: "mb-2"
  }, [_vm._v("Attachments")]), _c('div', {
    staticClass: "upload-box",
    on: {
      "click": _vm.triggerFileInput
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Upload Files")]), _c('span', {
    staticClass: "file-names",
    class: {
      empty: !_vm.files.length
    }
  }, [_vm._v(" " + _vm._s(_vm.files.length ? "".concat(_vm.files.length, " file").concat(_vm.files.length > 1 ? 's' : '', " selected") : "No file chosen") + " ")]), _c('input', {
    ref: "fileInput",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "multiple": "",
      "accept": ".pdf,.png,.jpg,.jpeg"
    },
    on: {
      "change": _vm.handleFile
    }
  })]), _c('div', {
    staticClass: "upload-info"
  }, [_vm._v(" Upload supporting documents (PDF, JPG, PNG). Max 5MB. ")]), _vm.files.length ? _c('div', {
    staticClass: "attachment-list mt-3"
  }, _vm._l(_vm.files, function (file, index) {
    return _c('div', {
      key: file.id,
      staticClass: "attachment-card"
    }, [_c('button', {
      staticClass: "attachment-preview-trigger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.previewFile(file);
        }
      }
    }, [_c('span', {
      staticClass: "attachment-icon",
      class: {
        'is-pdf': _vm.isPdf(file)
      }
    }, [_c('i', {
      class: _vm.isPdf(file) ? 'far fa-file-pdf' : 'far fa-image'
    })]), _c('span', {
      staticClass: "attachment-meta"
    }, [_c('span', {
      staticClass: "attachment-name",
      attrs: {
        "title": file.name
      }
    }, [_vm._v(_vm._s(file.name))]), _c('span', {
      staticClass: "attachment-size"
    }, [_vm._v(_vm._s(_vm.formatFileSize(file.size)))])])]), _c('div', {
      staticClass: "attachment-actions"
    }, [_c('button', {
      staticClass: "attachment-action-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.previewFile(file);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-eye"
    })]), _c('button', {
      staticClass: "attachment-remove-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.removeFile(index);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-times"
    })])])]);
  }), 0) : _vm._e()]), _c('div', {
    staticClass: "modal-actions mt-4"
  }, [_c('button', {
    staticClass: "btn btn-secondary fs-14",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Cancel")]), _c('button', {
    staticClass: "btn btn-linear-primary fs-14",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.saveNote
    }
  }, [_vm._v(" " + _vm._s(_vm.isLoading ? "Submitting..." : "Submit Issue") + " ")])])])]), _c('b-modal', {
    attrs: {
      "size": "xl",
      "centered": "",
      "hide-footer": "",
      "hide-header-close": "",
      "modal-class": "attachment-preview-modal",
      "content-class": "attachment-preview-content",
      "body-class": "attachment-preview-body"
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "attachment-preview-header"
        }, [_c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closePreviewModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.previewModalVisible,
      callback: function callback($$v) {
        _vm.previewModalVisible = $$v;
      },
      expression: "previewModalVisible"
    }
  }, [_vm.previewFileItem ? _c('div', {
    staticClass: "attachment-preview-shell"
  }, [_vm.isImage(_vm.previewFileItem) ? _c('img', {
    staticClass: "attachment-preview-image",
    attrs: {
      "src": _vm.previewFileItem.previewUrl,
      "alt": _vm.previewFileItem.name
    }
  }) : _vm.isPdf(_vm.previewFileItem) ? _c('iframe', {
    staticClass: "attachment-preview-pdf",
    attrs: {
      "src": _vm.previewFileItem.previewUrl,
      "frameborder": "0",
      "title": _vm.previewFileItem.name
    }
  }) : _vm._e()]) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }